import { render, staticRenderFns } from "./updateTicketType.vue?vue&type=template&id=10ea0f72&scoped=true"
import script from "./updateTicketType.vue?vue&type=script&lang=js"
export * from "./updateTicketType.vue?vue&type=script&lang=js"
import style0 from "./updateTicketType.vue?vue&type=style&index=0&id=10ea0f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ea0f72",
  null
  
)

export default component.exports